import { Reducer } from "redux";

import { ServiceRequestIsRetroDispatchTypes } from "models/DispatchTypes/AllPatientRecord";
import { ServiceRequestIsRetroActionDispatchTypes } from "constants/AllPatientRecord";
import { ServiceRequestIsRetroResponse } from "models/Api/AllPatientRecord";

export const initialState: ServiceRequestIsRetroResponse = {
  loading: false,
  response: {
    isRetro: false,
    effectiveEndDate: null,
    effectiveEndDateMinOneDay: null,
  },
};

const serviceRequestIsRetroReducer: Reducer<
  ServiceRequestIsRetroResponse,
  ServiceRequestIsRetroDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ServiceRequestIsRetroActionDispatchTypes.GET_SERVICE_REQUEST_IS_RETRO_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ServiceRequestIsRetroActionDispatchTypes.GET_SERVICE_REQUEST_IS_RETRO_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ServiceRequestIsRetroActionDispatchTypes.GET_SERVICE_REQUEST_IS_RETRO_RESET: {
      return initialState;
    }
    case ServiceRequestIsRetroActionDispatchTypes.GET_SERVICE_REQUEST_IS_RETRO_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default serviceRequestIsRetroReducer;

